<template>
  <div class="opponents">
    <div class="opponent">

      <div class="versus">
        <b class="is-text-link score">{{ IClassroom.mySchool.score }}</b>
        <b class="is-text-danger score">{{ IClassroom.opponent.score }}</b>
      </div>
      <div class="versus">
        <div v-show="showWin && IClassroom.mySchool.score === IClassroom.opponent.score" class="win">平局！</div>

        <div class="progress-bar"
             :style="{width: (100-width) + '%'}">
          <div v-show="showWin && IClassroom.mySchool.score > IClassroom.opponent.score" class="win">WIN！</div>
        </div>
        <div class="progress-bar is-danger"
             :style="{width: width + '%'}">
          <div v-show="showWin && IClassroom.mySchool.score < IClassroom.opponent.score" class="win">WIN！</div>
        </div>
        <div class="versus images">
          <img class="image" :src="$publicPath('/duck.jpg')" alt="">
          <img class="image" :src="IClassroom.opponent.image" alt="">
        </div>
      </div>
      <div class="versus">
        <div class="name">北京烤鸭大学</div>
        <div>对战</div>
        <div class="name">{{ IClassroom.opponent.name }}</div>
      </div>

    </div>

  </div>
</template>

<script>
import IClassroom from '@/components/classroom/lib/IClassroom'

export default {
  props: ['showWin'],
  data () {
    return {
      IClassroom,
      opponent: IClassroom.opponent
    }
  },
  computed: {
    width () {
      if (!IClassroom.opponent.score) return 50
      return ~~(IClassroom.opponent.score / (IClassroom.opponent.score + IClassroom.mySchool.score) * 100)
    }
  }
}
</script>

<style lang="stylus" scoped>
.opponents {
  position relative
  padding 1rem
  user-select none
}

.versus {
  display flex
  justify-content space-between
  font-size 12px
  margin-top 3px
  position relative
}

.score {
  font-size 20px
  line-height 1
}

.progress-bar {
  height 22px
  background $link
  border-radius 20px
  margin-top 3px
  display inline-block
  position relative

  &.is-danger {
    background $danger
  }
}

.images {
  position absolute
  width 100%
}

.image {
  width 24px
  border 2px solid white
  border-radius 50%
  box-shadow 0 0 0 2px $link

  &:last-child {
    box-shadow 0 0 0 2px $danger
  }
}

.win {
  position absolute
  top -15px
  left 50%
  transform translateX(-50%) rotate(-10deg) skewX(-20deg)
  white-space nowrap
  text-align center
  background white
  padding 0 10px 0 20px
  font-size 20px
  font-weight bold
  box-shadow 0 1px 0 3px $dark
  z-index 1
}
</style>
